import React from 'react'
import { Link } from 'react-router-dom'

import '../styles/navbar/navBar.css'

const NavBar = () => {
    return (
            <nav className="navbar navbar-expand-lg text-white">
                <div className="container-fluid" style={{ width:'90%', margin:'auto' }}>
                    <Link to='/' className="navbar-brand" >
                        <img src={process.env.PUBLIC_URL + '/images/boxOficLogo-darktheme.png'} alt="Logo" className='logo img-fluid' />
                    </Link>

                        <div className='right-nav'>
                            <Link to='/' className='nav-link'>Home</Link>
                            {/* <Link to='/about-us' className='nav-link '>About Us</Link> */}
                            <Link to='/contact-us' className='nav-link'>Contact Us</Link>
                            {/* <div className="nav-item dropdown" style={{marginLeft:'0.5rem'}}>
                                <Link to='/' className="nav-link dropdown-toggle" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    English
                                </Link>
                                <ul class="dropdown-menu">
                                    <li><Link to='hindi' className="dropdown-item">Hindi</Link></li>
                                </ul>
                            </div> */}

                        </div>
                </div>
            </nav>
    )
}

export default NavBar